const emptyDish = {
  id : "",
  name : "",
  chName : "",
  price : "",
  description : "",
  background : { image : null },
}

export default emptyDish
